<template>
<div>
  <div class="col-md-12">
    <canvas height="250" id="source-chart-failure"></canvas>
  </div>
</div>
</template>

<script>
import Chart from 'chart.js'
export default {
  name: 'bookingSuccess',
  data() {
    return {
      loading: false,
      chartData: [],
      labelData: []
    };
  },
  watch:{
  },
  mounted() {
  },
  created(){
    this.loadData()
  },
  methods:{ 
    async loadData() {
      try {
        var bookingStats = await this.$store.dispatch("fail_source_list")
        this.chartData = [bookingStats[1].failure_android,bookingStats[2].failure_web,bookingStats[3].failure_ios]
        this.labelData = ["Android", "Web", "IOS"]
      } finally {
        const ctx = document.getElementById('source-chart-failure');
        var sourceChartFailure = {
          type: 'bar',
          data: {
            labels: this.labelData,
            datasets: [
              {
                data: this.chartData,
                backgroundColor:'rgba(75, 192, 192, 0.2)',
                borderColor:'rgb(54, 162, 235)',
                borderWidth: 2
              },
            ]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                      drawBorder: false
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(128,0,0,0.05)",
                      drawBorder: false
                  },
                }
              ]
            }
          },
        }
        new Chart(ctx, sourceChartFailure);
      }
    }
  },
  computed:{}
};
</script>

<style></style>